// @material-ui/icons
import Flight from "@material-ui/icons/Flight";
import Settlement from "@material-ui/icons/Style";
import Settings from "@material-ui/icons/SettingsApplications";
import Passenger from "@material-ui/icons/AirlineSeatReclineExtra";
import Email from "@material-ui/icons/Email";
import Audit from "@material-ui/icons/TrackChanges";
import AirlinesPassengerPage from "views/AirlinesPassenger/Index.jsx";
import AirlinePaymentPage from "views/AirlinePayment/Index.jsx";
import SettlementPage from "views/Settlement/Index.jsx";
import SettingsPage from "views/Settings/Index.jsx";
import EmailSettings from "views/EmailSettings/Index.jsx";
import NotFound from "views/NotFound/Index.jsx";
import OutstandingSettlementPage from "views/OutstandingSettlement/Index.jsx";


const dashboardRoutes = [
    {
        path: "/app/passenger-data",
        sidebarName: "Passenger Data",
        navbarName: "Airline Passenger Data",
        icon: Passenger,
        subMenu: [],
        component: AirlinesPassengerPage
    },
    {
        path: "/app/airline-payment",
        sidebarName: "Airline Payment",
        navbarName: "Airline Payment Report",
        icon: Flight,
        subMenu: [],
        component: AirlinePaymentPage
    },
    {
        path: "/app/psc-settlement",
        sidebarName: " PSC Settlement",
        navbarName: "PSC Settlement",
        icon: Settlement,
        subMenu: [],
        component: SettlementPage
    },
    {
        path: "/app/outstanding-settlement",
        sidebarName: "Outstanding Settlement",
        navbarName: "Outstanding Settlement",
        icon: Settlement,
          subMenu: [],
          component: OutstandingSettlementPage
      },
    {
        path: "/app/settings",
        sidebarName: "Settings",
        navbarName: "Settings",
        subMenu: [
            {
                path: "/app/settings",
                sidebarName: "Re-order Level",
                navbarName: "Re-order Level",
                component: SettingsPage
            },
            {
                path: "/app/emailSettings",
                sidebarName: "Email Settings",
                navbarName: "Email Settings",
                icon: Email,
                component: EmailSettings
            },
        ],
        icon: Settings,
        component: SettingsPage
    },
    {
        path: "/app/emailSettings",
        sidebarName: "Email Settings",
        navbarName: "Email Settings",
        icon: Email,
        isNotVisible: true,
        component: EmailSettings,
        subMenu: [],

    },
    {
        isNotVisible: true,
        path: "**",
        sidebarName: "Not found",
        navbarName: "Not Found",
        icon: Audit,
        subMenu: [],
        component: NotFound,

    }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/supervisor.jsx